module.exports = __webpack_public_path__ + "static/media/cutsglare_japanese_00073.dce1751c.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/jp/cutsglare_japanese_00073.png
// module id = 2298
// module chunks = 0